import { getData, STATIC_MEDIA_URL } from '../api/max';
export const getResponsiveImageProps = (imageProps, targetWidth, targetHeight) => {
    const { displayMode, uri, width, height, name, crop, focalPoint, alignType, quality, upscaleMethod, hasAnimation, allowAnimatedTransform, } = imageProps;
    const { srcset, css } = getData(displayMode, { id: uri, width, height, name, crop, focalPoint }, {
        width: targetWidth,
        height: targetHeight,
        alignment: alignType,
    }, {
        focalPoint,
        name,
        quality: quality?.quality,
        upscaleMethod,
        hasAnimation,
        allowAnimatedTransform,
        useSrcset: true,
    });
    const srcsetString = srcset?.dpr
        ?.map((s) => (/^[a-z]+:/.test(s) ? s : `${STATIC_MEDIA_URL}${s}`))
        .join(', ') || '';
    return {
        srcset: srcsetString,
        css,
    };
};
//# sourceMappingURL=responsiveImageUtils.js.map